// @flow
import {
  WebComponent,
} from 'fg-frontend';

const fragments = {
  LVL1TOGGLE: '[data-fragment="SectionList.lvl1Trigger"]',
  LVL2TOGGLE: '[data-fragment="SectionList.lvl2Trigger"]',
  LVL1LIST: '[data-fragment="SectionList.lvl1List"]',
  LVL2LIST: '[data-fragment="SectionList.lvl2List"]',
  LVL1AMOUNT: '[data-fragment="SectionList.lvl1Amount"]', // amount of items lvl 1
  LVL2AMOUNT: '[data-fragment="SectionList.lvl2Amount"]', // amount of items lvl 2
  SECTION: '[data-fragment="SectionList.section"]',
  SUBSECTION: '[data-fragment="SectionList.subsection"]',
};

export default class SectionList extends WebComponent {
  constructor(props) {
    super(props);
    this.handleOpenLvlOne = this.handleOpenLvlOne.bind(this);
    this.handleOpenLvlTwo = this.handleOpenLvlTwo.bind(this);
  }

  didMount() {
    this.section = this.element.querySelectorAll('.download__section');
    this.subsection = this.element.querySelectorAll('.download__subsection');
    this.lvl1Toggle = this.element.querySelectorAll(fragments.LVL1TOGGLE);
    this.lvl2Toggle = this.element.querySelectorAll(fragments.LVL2TOGGLE);
    this.lvl1Amount = this.element.querySelectorAll(fragments.LVL1AMOUNT);
    this.lvl2Amount = this.element.querySelectorAll(fragments.LVL2AMOUNT);

    if (this.section) {
      // calculate amount of items and amend toggle
      this.section.forEach((section) => {
        if (section.classList.contains('download__section--has-subsections')) {
          const am = section.querySelectorAll(fragments.LVL2AMOUNT);
          let finalAmount = 0;
          am.forEach((amount) => {
            finalAmount += Number(amount.innerHTML);
          });
          section.querySelector('.download__section-title').firstElementChild.innerHTML = `(${finalAmount})`;
        }
      });
    }

    if (this.lvl1Toggle) {
      this.lvl1Toggle.forEach((toggle) => {
        toggle.addEventListener('click', this.handleOpenLvlOne);
      });
    }

    if (this.lvl2Toggle) {
      this.lvl2Toggle.forEach((toggle) => {
        toggle.addEventListener('click', this.handleOpenLvlTwo);
      });
    }
  }

  handleOpenLvlOne = (e) => {
    const container = e.target.parentElement;

    function scrollToTargetAdjusted(target) {
      let offset = 45;
      if (window.innerWidth >= 1280) {
        offset = 120;
      }
      const elementPosition = target.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth',
      });
    }

    setTimeout(() => {
      scrollToTargetAdjusted(container);
    }, 500);

    if (container.classList.contains('download__section--is-opened')) {
      container.classList.toggle('download__section--is-opened');
    } else {
      // remove active classes
      this.section.forEach((section) => {
        section.classList.remove('download__section--is-opened');
      });
      // add class to the actual
      container.classList.add('download__section--is-opened');
      // container.scrollIntoView({behavior: "smooth"});
    }
  };

  handleOpenLvlTwo = (e) => {
    const container = e.target.parentElement;
    if (container.classList.contains('download__subsection--is-opened')) {
      container.classList.toggle('download__subsection--is-opened');
    } else {
      // remove active classes
      this.subsection.forEach((section) => {
        section.classList.remove('download__subsection--is-opened');
      });
      // add class to the actual
      container.classList.add('download__subsection--is-opened');
    }
  };

  willUnMount() {
  }
}




// WEBPACK FOOTER //
// ./fe/web-default/src/js/components/SectionList.js